import React from 'react';
import { Box, Grid, IconButton, Typography } from '@mui/material';
import NumberFormat, { NumberFormatValues } from 'react-number-format';
import { ArrowDropDown, ArrowDropUp } from '@mui/icons-material';
import { COLORS_COOLGRAY } from '../../../App.constants';
import { CustomOutlinedInput } from '../../shared/custom-outlined-input/CustomOutlinedInput';

interface IProps {
  direction?: 'column' | 'row';
  inputValue: number;
  label: string;
  onInputChange: (val: number) => void;
  subLabel: string;
  type: 'currency' | 'percent' | 'none';
}
export const DialFieldMobile: React.FC<IProps> = (props) => {
  const { direction = 'column' } = props;
  const prefix = props.type === 'currency' ? '$' : undefined;
  const suffix = props.type === 'percent' ? '%' : undefined;
  const iconStyle = { padding: 0, width: '14px', height: '14px' };

  return (
    <Grid
      item={true}
      container={true}
      direction={direction}
      marginBottom={3}
      paddingX={6}
    >
      <Typography fontSize={'1rem'}>{props.label}</Typography>

      <Grid
        item={true}
        container={true}
        flexDirection={'row'}
        justifyContent={'flex-start'}
      >
        <Grid
          item={true}
          position={'relative'}
          xs={8}
        >
          <NumberFormat
            value={props.inputValue}
            prefix={prefix}
            suffix={suffix}
            size={'small'}
            color={'info'}
            fullWidth={true}
            thousandSeparator={true}
            customInput={CustomOutlinedInput}
            isNumericString={true}
            onValueChange={(values: NumberFormatValues) => props.onInputChange(values.floatValue ?? 0)}
          />
          <Box
            display={'flex'}
            flexDirection={'column'}
            position={'absolute'}
            right={'5px'}
            top={'-4px'}
          >
            <IconButton
              onClick={() => props.onInputChange(props.inputValue + 1)}
              sx={{ ...iconStyle, marginTop: '10px' }}
            >
              <ArrowDropUp />
            </IconButton>
            <IconButton
              onClick={() => props.onInputChange(props.inputValue - 1)}
              sx={{ ...iconStyle, marginBottom: '10px' }}
            >
              <ArrowDropDown />
            </IconButton>
          </Box>
        </Grid>

        <Grid
          item={true}
          container={true}
          xs={4}
          alignItems={'center'}
          paddingLeft={2}
        >
          <Typography
            fontSize={'1rem'}
            fontStyle={'italic'}
            color={COLORS_COOLGRAY}
          >
            {props.subLabel}
          </Typography>
        </Grid>
      </Grid>
    </Grid>
  );
};

DialFieldMobile.displayName = 'DialFieldMobile';
